import React from 'react'
import { AppHeader } from 'src/business/components';
import { BusinessEventsWidget } from 'src/business/components/bookingWidgets';

const BookingsPage = () => {


    return (
        <>
            <AppHeader heading="Bookings" />
            <div className="px-3">
                <BusinessEventsWidget />
            </div>
        </>
    )

}

export default BookingsPage;